export enum DxDiagnosisResultStatus {
  IN_PROGRESS = 1,
  COMPLETED = 2,
  DELETED = 3,
}

export const getDxDiagnosisResultStatusLabel = (status: DxDiagnosisResultStatus): string => {
  switch (status) {
    case DxDiagnosisResultStatus.IN_PROGRESS:
      return '回答中';
    case DxDiagnosisResultStatus.COMPLETED:
      return '回答済み';
    case DxDiagnosisResultStatus.DELETED:
      return '削除済み';
    default:
      return '不明';
  }
};
